export default __webpack_public_path__ + "static/media/1.11ad52d4.jpg";